<template>
    <div class="row">

        <div class="col-12">
            <article class="product">
                <div class="row">
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="product-gallery relative-galery default">
                            <img class="zoom-img" id="img-product-zoom" :src="productInfo.MainPicPath" :data-zoom-image="productInfo.MainPicPath" width="411" @error="imageLoadOnError" :title="productInfo.Name.replace(/\s+/g, '-')" :alt="productInfo.ShortName.replace(/\s+/g, '-') +' ' +  productInfo.Name.replace(/\s+/g, '-')" />
                            <div id="gallery_01f" style="width:500px;float:left;">



                                <div class="owl-carousel owl-carousel-nav">
                                    <div class="item">
                                        <a href="#" :title="productInfo.Name" class="elevatezoom-gallery" data-update="" :data-image="productInfo.MainPicPath" :data-zoom-image="productInfo.MainPicPath">
                                            <img :src="productInfo.MainPicPath" width="100" @error="imageLoadOnError" :title="productInfo.Name.replace(/\s+/g, '-')" :alt="productInfo.ShortName.replace(/\s+/g, '-') +' ' +  productInfo.Name.replace(/\s+/g, '-')" />
                                        </a>
                                    </div>
                                    <div class="item" v-if="productInfo.ProductPics != null" v-for="(pic,index) in productInfo.ProductPics">
                                        <a href="#" :title="productInfo.Name" :class="['elevatezoom-gallery',(index == 0)? 'active' : '']" data-update="" :data-image="pic.FilePath" :data-zoom-image="pic.FilePath">
                                            <img :src="pic.FilePath" width="100" @error="imageLoadOnError" :title="productInfo.Name.replace(/\s+/g, '-')" :alt="productInfo.ShortName.replace(/\s+/g, '-') +' ' +  productInfo.Name.replace(/\s+/g, '-')" />
                                        </a>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <ul class="gallery-options">
                            <!--<li>
                            <router-link title="مقایسه محصول" tag="button" :to="{ name: 'compareProduct' , query: { productId: productInfo.Id, SubGroupId: productInfo.SubGroupId } }" class="add-favorites">-->
                            <!--<img style="width:32px;" src="/assets/img/Compare-256.svg" />-->
                            <!--<i class="fa fa-toggle-on"></i>
                                </router-link>
                                <span class="tooltip-option">مقایسه محصول</span>
                            </li>-->
                            <!--<li>
                                <button data-toggle="modal" data-target="#productShare"><i class="fa fa-share-alt"></i></button>
                                <span class="tooltip-option">اشتراک گذاری</span>
                            </li>-->
                            <!--<li>
                                <button @click="openChangesPriceProduct"><i class="fa fa-bar-chart"></i></button>
                                <span class="tooltip-option">تغییرات قیمت</span>
                            </li>-->
                        </ul>


                        <changePrices-component :ProductSaleParams="productInfo.ProductSaleParams"></changePrices-component>

                        <!-- Modal Core ChangesPriceProduct-->
                    </div>
                    <div :class="productInfo.HighlightedProductPropertyValue.length > 0 ? 'col-lg-4 col-md-6 col-sm-12' : 'col-lg-8 col-md-6 col-sm-12'">
                        <div class="row">
                            <div class="product-title default">
                                <ul class=" line-e-t">
                                    <li>
                                        <p>
                                            {{productInfo.Name}}
                                            <!--<span>{{productInfo.ShortName}}</span>-->
                                        </p>
                                    </li>

                                </ul>


                            </div>

                            <div class="product-directory default">
                                <ul class="line-e-t">
                                    <li>
                                        <span>‌گروه </span> :
                                        <span class="product-brand-title">{{productInfo.GroupTitle}}</span>
                                    </li>
                                    <li class="li-linle">

                                    </li>
                                    <li>
                                        <span>زیر گروه</span> :
                                        <router-link target="_blank" :to="{ path: '/filter', query: { SubGroupId: productInfo.SubGroupId , SubGroupName: productInfo.SubGroupTitle }}" :title="productInfo.SubGroupTitle" class="btn-link-border" v-text="">
                                            {{productInfo.SubGroupTitle}}
                                        </router-link>
                                    </li>
                                    <li class="li-linle"  v-if="productInfo.Catalog != null">

                                    </li>
                                    <li  v-if="productInfo.Catalog != null">
                                        <span>دریافت کاتالوگ</span> :
                                        <a :href="productInfo.Catalog" target="_blank" class="btn-link-border">
                                            دانلود
                                        </a>
                                    </li>
                                    <li class="li-linle" v-if="productInfo.BrandId > 0">

                                    </li>
                                    <li v-if="productInfo.BrandId > 0">
                                        <span>برند</span> :
                                        <router-link target="_blank" :to="{ path: '/filter', query: { BrandCode: productInfo.BrandId , BrandName: productInfo.BrandTitle }}" :title="productInfo.BrandTitle" class="btn-link-border" v-text="">
                                            {{productInfo.BrandTitle}}
                                        </router-link>

                                    </li>

                                </ul>
                            </div>
                            <div class="product-directory default">
                                <ul class="line-e-t">
                                    <li>
                                        <span style="font-size:14px" class="bold">‌کد کالا </span> :
                                        <span style="font-size:14px" class="product-brand-title bold">{{productInfo.Code}}</span>
                                    </li>


                                </ul>
                            </div>
                            <div style="margin-right: 15px;" v-show="isShowAttributeSelector" class="product-variants default" v-if="saleParam != null">
                                <span> انتخاب کنید: </span>
                                <div class="form-account-row">
                                    <select class="input-field input-field-size-color" v-model="saleParam" @change="setSaleParam(saleParam)">
                                        <option v-for="productSaleParam in productInfo.ProductSaleParams" :value="productSaleParam">{{productSaleParam.Name == '' ? '---------' : productSaleParam.Name}}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="product-guarantee default" v-if="stockInventory != 0">
                                <div class="flex flex-right">
                                    <div class="flex flex-right ">وضعیت : </div>
                                    <div class="dd-po">
                                        <!--<i class="fa fa-check-circle"></i>-->
                                        <span class="product-guarantee-textc c_87c25e"> موجود </span>
                                    </div>
                                </div>

                            </div>
                            <div class="product-guarantee default" v-if="!stockInventory != 0">
                                <div class="flex flex-right">
                                    <div class="price-main-title">وضعیت : </div>
                                    <div class="dd-po">
                                        <!--<i class="fa fa-close ef5662"></i>-->
                                        <span class="product-guarantee-text ef5662">  جهت استعلام قیمت تماس بگیرید </span>
                                    </div>
                                </div>

                            </div>
                       
                            <div class="d-block d-sm-none">
                                <div class="flowbox-infoProduct ">
                                    <div class="price-product defualt w-100">

                                        <div v-if="stockInventory != 0" class="flex flex-left">
                                            <!--<span class="price-main-title">قیمت محصول :</span>-->
                                            <div v-if="productInfo.Price != 0" :class="[(productInfo.DiscountPercent == 0) ? 'price-main-at':'price-main']">
                                                <div class="price-value">
                                                    <span v-if="productInfo.DiscountPercent == 0"> {{(productInfo.Price + paddingPrice) | formatNumber }}</span>
                                                    <span class="discount" v-if="productInfo.DiscountPercent > 0">
                                                        {{((productInfo.Price + paddingPrice ) - (((productInfo.Price + paddingPrice) * productInfo.DiscountPercent)/100))  | formatNumber  }}
                                                        <span class="discountvalue" v-if="productInfo.DiscountPercent > 0">   {{(productInfo.Price + paddingPrice) | formatNumber}}  <span class="discountvalue-t"> تومان </span></span>

                                                    </span>
                                                    <span class="price-currency"> تومان </span>
                                                </div>
                                                <div style=" margin: 5px 0" v-if="productInfo.DiscountPercent != 0" class="price-discount">
                                                    <span>
                                                        {{productInfo.DiscountPercent}}
                                                    </span>
                                                    <span>%</span>
                                                </div>
                                            </div>
                                            <div v-else class="callToMain w-100">
                                                <span class="call w-100">جهت استعلام قیمت تماس بگیرید</span>
                                            </div>

                                        </div>

                                    </div>
                                    <div v-if="productInfo.IsShowPreOrderBtn">
                                        <div v-if="saleParam != null && stockInventory != 0 && productInfo.Price != 0" class="product-add-cart">
                                            <div class="addtocart" >
                                                <a @click="addToCart(saleParam.Id)" class="dk-btn dk-btn-info">
                                                    افزودن به سبد خرید

                                                </a>
                                                <div id="showloaderbtnaddcart" class="show-lo">
                                                    <div class="div-loader">
                                                        <img src="/assets/img/loader/loader.svg" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!--<div v-else class="product-add default">
                    <div class="parent-btn" v-if="productInfo.Price != 0">
                        <button disabled="disabled" href="#" class="disadledbtn dk-btn dk-btn-info">
                            ناموجود

                        </button>
                    </div>
                </div>-->
                                    </div>
                                </div>
                            </div>

                            <div class="d-none d-sm-block">
                                <div class="price-product defualt col-12 ">
                                    <div class="row">
                                        <div v-if="stockInventory != 0" class="col-12 flex flex-right">
                                            <span class="price-main-title">قیمت محصول :</span>
                                            <div v-if="productInfo.Price != 0" :class="[(productInfo.DiscountPercent == 0) ? 'price-main-at':'price-main']">
                                                <div class="price-value">
                                                    <span v-if="productInfo.DiscountPercent == 0"> {{(productInfo.Price + paddingPrice) | formatNumber }}</span>
                                                    <span class="discount" v-if="productInfo.DiscountPercent > 0">
                                                        {{((productInfo.Price + paddingPrice ) - (((productInfo.Price + paddingPrice) * productInfo.DiscountPercent)/100))  | formatNumber  }}
                                                        <span class="discountvalue" v-if="productInfo.DiscountPercent > 0">   {{(productInfo.Price + paddingPrice) | formatNumber}}  <span class="discountvalue-t"> تومان </span></span>

                                                    </span>
                                                    <span class="price-currency"> تومان </span>
                                                </div>
                                                <div v-if="productInfo.DiscountPercent != 0" class="price-discount" data-title="تخفیف">
                                                    <span>
                                                        {{productInfo.DiscountPercent}}
                                                    </span>
                                                    <span>%</span>
                                                </div>
                                            </div>
                                            <div v-else class="callToMain">
                                                <span class="call">جهت استعلام قیمت تماس بگیرید</span>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div v-if="productInfo.IsShowPreOrderBtn">
                                    <div v-if="saleParam != null && stockInventory != 0 && productInfo.Price != 0" class="col-12 product-add-cart">
                                        <div class="addtocart">
                                            <a @click="addToCart(saleParam.Id)" class="dk-btn dk-btn-info">
                                                افزودن به سبد خرید
                                                <i class="now-ui-icons shopping_cart-simple"></i>
                                            </a>
                                            <div id="showloaderbtnaddcart" class="show-lo">
                                                <div class="div-loader">
                                                    <img src="/assets/img/loader/loader.svg" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--<div v-else class="col-12 product-add default">
                <div class="parent-btn" v-if="productInfo.Price != 0">
                    <button disabled="disabled" href="#" class="disadledbtn dk-btn dk-btn-info">
                        ناموجود

                    </button>
                </div>
            </div>-->
                                </div>
                            </div>

                            <selected-cart-modal :productInfo="productInfo"></selected-cart-modal>
                        </div>

                    </div>
                    <div v-if="productInfo.HighlightedProductPropertyValue.length > 0"
                         class="col-lg-4 col-md-6 col-sm-12 center-breakpoint">
                        <div class="product-params default">
                            <ul data-title="ویژگی‌های محصول">
                                <li></li>
                                <li v-for="Highlighted in  productInfo.HighlightedProductPropertyValue">
                                    <h3 style="font-size:13px;" v-if="Highlighted.PropertyValue != ''">
                                        {{ Highlighted.PropertyTitle }} : {{Highlighted.PropertyValue == null || Highlighted.PropertyValue == '' ? '----' : Highlighted.PropertyValue}}
                                    </h3>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-lg-12 col-md-12 col-sm-12 ">
                        <div class="tst-w" style="width:100%">
                            <div class="ai-center-fr jc-between fl-f">
                                <a class="footer-features">
                                    <div>
                                        <img class="ls-is-cached" alt="ضمانت اصالت" src="/assets/img/footer/ضمانت_اصالت.png">
                                    </div>
                                    <p class="d-none d-sm-block text-caption color-700">ضمانت اصالت</p>
                                </a>
                                <a class="footer-features">
                                    <div>
                                        <img class="ls-is-cached" alt="مناسب ترین قیمت" src="/assets/img/footer/مناسب_تر_قیمت.png">
                                    </div>
                                    <p class="d-none d-sm-block text-caption color-700">مناسب ترین قیمت</p>
                                </a>
                                <a class="footer-features">
                                    <div>
                                        <img class="ls-is-cached" alt="تحویل_سریع" src="/assets/img/footer/تحویل_سریع.png">
                                    </div>
                                    <p class="d-none d-sm-block text-caption color-700">تحویل سریع</p>
                                </a>
                                <a class="footer-features">
                                    <div>
                                        <img class="ls-is-cached" alt="امکان برگشت کالا" src="/assets/img/footer/بازگشت_کالا.png">
                                    </div>
                                    <p class="d-none d-sm-block text-caption color-700">امکان برگشت کالا</p>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div v-if="description != null" class="col-lg-12 col-md-12 col-sm-12 center-breakpoint">
                        <hr />
                        <article>
                            <!--<div class="t-t-title">
                                <h3 style="font-size:20px ;font-weight:bold">
                                    <strong>توضیحات</strong>    
                                </h3>
                            </div>-->
                            <div class="text-p-description" v-html="description"> </div>
                        </article>

                    </div>
                </div>
            </article>
        </div>
    </div>
</template>

<script>
    import { setCart } from "../../module/cart";
    import { httpPromise } from "../../module/httpUtility";
    import changePrices from "./changePrices.vue";
    import selectedCart from "../productComponents/selectedCartModal.vue";


    export default {
        props: {
            productInfo: {
                type: Object,
            },
        },
        components: {
            'changePrices-component': changePrices,
            'selected-cart-modal': selectedCart,
        },
        data() {
            return {
                description: '',
                saleParam: null,
                stockInventory: 0,
                isShowAttributeSelector: true,
                paddingPrice: 0,
                linkProduct: '#'
            }
        },
        computed: {
            cart: function () {
                return this.$store.getters.readCart;
            },
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        },
        methods: {
            openChangesPriceProduct() {
                $(function () {
                    $('#changesPriceProduct').modal({ backdrop: 'static', keyboard: false });
                    $('#changesPriceProduct').modal('show');
                });
            },
            copylinkPage() {
                var copyText = document.querySelector("#texturlproduct");
                copyText.select();
                document.execCommand("copy");
                $(function () {
                    var $temp = $("<input id='A' type='text' value='#' />".replace(/#/g, $('.textlinkpage').text()));
                    $("body").append($temp);
                    $('.linkpagecopyBtn').addClass('copied');
                    $('.linkpagecopyBtn').html('کپی شد');
                    setTimeout(function () {
                        $('.linkpagecopyBtn').removeClass('copied');
                        $('.linkpagecopyBtn').html('کپی لینک')
                    }, 2000)
                });

            },
            setSaleParam(saleParam) {
                this.paddingPrice = saleParam.PaddingPrice;
                this.stockInventory = saleParam.StockInventory;
            },
            addToCart(productSaleParamId) {
                setCart(this, productSaleParamId, "Increase", '#showloaderbtnaddcart', function () {
                    $(function () {
                        //   $('#selectedCartModal').modal({ backdrop: 'static', keyboard: false });
                        $('#selectedCartModal').modal('show');
                        toastr.remove();
                    });
                });
            },
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-image-available.png";
            },
            //Increase(productId) {
            //    setCart(this, productId, 'Increase', '.loader');
            //},
            //Decrease(productId) {
            //    setCart(this, productId, 'Decrease', '.loader');
            //},
            filterBySubGroup(id, name) {
                this.$router.push({ name: 'filter', query: { SubGroupId: id, SubGroupName: name } });
                this.isShowSearchResult = false;
            },
        },
        beforeMount: function () {
            this.linkProduct = window.location.href;
            this.saleParam = this.productInfo.ProductSaleParams == null ? null : this.productInfo.ProductSaleParams[0];
            this.stockInventory = this.saleParam == null ? 0 : this.saleParam.StockInventory;
            this.paddingPrice = this.saleParam == null ? 0 : this.saleParam.PaddingPrice;
            if (this.productInfo.ProductSaleParams != null && this.productInfo.ProductSaleParams.length == 1 && this.saleParam.HasAttributes == false) {
                this.isShowAttributeSelector = false;
            }
            initializeChart();
            //-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
            httpPromise(this, '/v1/ProductManagement/ProductDescriptions/Find', 'get', { ProductId: this.$route.params.productId },
                response => {
                    this.description =response.data.Value != null ? response.data.Value.Description : null;
                },
                response => {

                }
            );
        },
        beforeDestroy() {
            $(function () {
                $('#img-product-zoom-ZoomContainer').remove();
            });

        },
    }
</script>



<style scoped>
    .flex-left {
        justify-content: left;
    }

    .flowbox-infoProduct .price-product .price-discount span {
        font-size: 15px;
        line-height: 28px;
    }

    .flowbox-infoProduct a.dk-btn {
        padding: 7px 15px 7px 12px !important;
    }

    .flowbox-infoProduct .dk-btn::before {
        width: unset;
        height: unset;
    }

    .flowbox-infoProduct a.dk-btn {
        margin-top: 0;
        overflow: hidden;
        padding: 10px 40px 10px 12px;
        font-size: 12px;
    }

    .flowbox-infoProduct .price-main {
        padding: 15px 0 0 10px;
    }

    .flowbox-infoProduct .price-value {
        font-size: 22px;
        line-height: 35px;
        margin-right: 3px;
        margin-left: 5px;
    }

    .flowbox-infoProduct .price-product .price-discount {
        height: 27px;
        padding: 0px 7px;
    }

    .flowbox-infoProduct .product-add-cart {
        margin-top: 6px;
        margin-bottom: 2px;
        margin-right: 10px;
    }

    .flowbox-infoProduct {
        width: 100%;
        z-index: 999;
        background-color: #fff;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-flow: row-reverse;
        padding: 10px 0 10px 0;
    }

    .tst-w .footer-features img {
        width: 76% !important;
    }

    .fl-f {
        display: flex;
        justify-content: space-around;
        width: 100%;
        margin-top: 15px;
    }

    .dd-po {
        margin-right: 10px;
        display: inline-block;
    }

    .flex-right {
        justify-content: right;
    }

    .line-e-t .price-main-at {
        padding: 0px 20px 0 0;
        display: inline-block;
    }

    .line-e-t .price-main {
        padding: 20px 15px 0 0;
    }

    .line-e-t .li-linle {
        border-left: 1px solid #ddd;
        margin: 0 20px 0 0;
    }

    main.single-product .line-e-t {
        font-size: 10px;
        font-size: .857rem;
        line-height: 1.833;
        max-width: 100%;
        padding-left: 90px;
        list-style: none;
        margin: 5px 0;
        background-color: transparent;
        padding: 0;
    }

    .line-e-t {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        padding: .75rem 1rem;
        margin-bottom: 1rem;
        list-style: none;
        background-color: #e9ecef;
        border-radius: .25rem;
    }

    main.single-product .line-e-t li::befor {
        content: "/";
        color: transparent;
        letter-spacing: .4px;
        font-size: 13px;
        vertical-align: top;
        margin-left: 5px;
        padding-right: 5px;
        font-weight: 400 !important;
    }

    .t-t-title h1 {
        font-size: 23px;
        font-weight: bold;
        margin-bottom: 13px;
        color: #666;
    }
    .t-t-title p {
        font-size: 23px;
        font-weight: bold;
        margin-bottom: 13px;
        color: #666;
    }
    .textlinkpage {
        display: block;
        width: 100%;
        margin-bottom: 20px;
        margin-top: 15px;
    }

    .btn-share-whatsap {
        background: #1bd741;
        border: 1px solid #1bd741;
    }

    .count-Item {
        background-color: #fff;
        width: 50px;
        height: 25px;
        font-size: 18px;
        font-size: 1.286rem;
        line-height: 28px;
        vertical-align: middle;
        letter-spacing: -.3px;
        text-align: center;
        color: #00bfd6;
        border-radius: 100%;
        display: inline-block;
        margin-right: 5px;
        margin-left: 7px;
    }

    .td-cart-box-counter {
        margin-top: 30px;
    }

        .td-cart-box-counter .cart-box-counter {
            text-align: center;
            position: relative;
        }

            .td-cart-box-counter .cart-box-counter .incress {
                position: absolute;
                font-size: 18px;
                vertical-align: top;
                display: inline-block;
                color: #fff;
                cursor: pointer;
                background-color: #aae67c;
                padding: 5px;
                border-radius: 5px;
                width: 30px;
                height: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                top: 0px;
                right: 10%;
            }

            .td-cart-box-counter .cart-box-counter .decress {
                position: absolute;
                font-size: 18px;
                vertical-align: top;
                display: inline-block;
                color: #fff;
                cursor: pointer;
                background-color: #e38686;
                padding: 5px;
                border-radius: 5px;
                width: 30px;
                height: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                top: 0px;
                left: 10%;
            }

        .td-cart-box-counter::before {
            font-size: 15px;
            bottom: 10px;
            width: 25px;
            height: 25px;
        }

        .td-cart-box-counter::after {
            font-size: 15px;
            top: 16px;
            width: 25px;
            height: 25px;
        }

    .product-title h1 {
        margin-bottom: 0;
    }
    .product-title p {
        margin-bottom: 0;
    }


    .disadledbtn {
        padding: 15px 50px;
    }

    .input-field-size-color {
        padding: 7px 11px 7px 11px;
        width: 56%;
        letter-spacing: unset;
        font-family: iranyekan;
    }

    .price-main-title {
        font-weight: bold;
    }

    .price-main {
        padding: 20px 20px 0 0;
    }



    .display-in-bl {
        display: inline-block;
    }

    .discountvalue-t {
        position: absolute;
        left: -40px;
    }

    .show-lo {
        display: none;
    }

    .product-add-cart {
        margin-top: 35px;
    }

    .addtocart {
        display: inline-block;
        position: relative
    }

    .div-loader {
        bottom: 6px;
    }


    a.dk-btn, a.dk-btn:hover {
        color: #fff;
    }

    a.dk-btn {
        margin-top: 0;
        overflow: hidden;
        padding: 10px 40px 10px 12px;
        font-size: 15px;
    }

    .dk-btn > i {
        right: 10px;
        top: 12px;
        font-size: 19px;
    }

    .dk-btn::before {
        right: -5px;
        top: -12px;
    }

    .discount {
        display: inline-block;
        position: relative;
        font-size: 18px;
    }

        .discount::after {
            content: "";
            width: 100%;
            position: absolute;
            left: 0px;
            border-top: 1px solid #c6c6c6;
            -webkit-transform: rotate(-30deg);
            transform: rotate(0deg);
            top: -1px;
        }

    .discountvalue {
        position: absolute;
        top: -19px;
        right: 1px;
        font-size: 16px;
        color: #c6c6c6;
    }

    .tages-generate ul li a {
        background-color: #ccc;
        padding: 0 10px 2px 11px;
        color: #fff;
        border-radius: 8px;
        transition: all .3s;
        font-size: 13px;
    }

    .tages-generate ul li {
        float: right;
        margin-right: 10px;
        margin-top: 10px;
    }

    .tages-generate ul {
        margin-top: 6px;
    }

        .tages-generate ul li:hover a {
            transition: all .3s;
            color: #777;
        }

    .price-product {
        margin-right: 16px;
    }

    .fl-f div {
        text-align: center;
    }

    .fl-f p {
        text-align: center;
    }

    @media only screen and (min-width: 640px) and (max-width: 990px) {
        .fl-f img {
            width: 60%;
        }

        .fl-f div {
            text-align: center;
        }

        .fl-f p {
            font-size: 12px;
            text-align: center;
        }
    }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .fl-f img {
            width: 60%;
        }

        .fl-f div {
            text-align: center;
        }

        .fl-f p {
            font-size: 12px;
            text-align: center;
        }

        .discount {
            font-size: 16px;
        }

        .line-e-t .li-linle {
            border-left: unset;
            margin: 0 20px 0 0;
        }

        .discountvalue {
            font-size: 15px;
        }

        .flowbox-infoProduct .discountvalue {
            font-size: 13px;
        }

        .flowbox-infoProduct .discount {
            font-size: 14px;
        }

        .flowbox-infoProduct .price-currency {
            font-size: 16px;
        }

        .flowbox-infoProduct .dk-btn {
            font-size: 16px !important;
        }
    }
</style>